import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import PrintoutSettings from '@/components/calculator/printout/PrintoutSettings.vue';
import OffersPreview from '@/components/calculator/printout/OffersPreview.vue';
import Deal from '@/models/Deal';
import SimulationDealPicker from '../results/SimulationDealPicker.vue';
import SendOffersConfirmModal from '@/components/calculator/results/offers/SendOffersConfirmModal.vue';
import { useSimulationStore } from '../services/SimulationStore';
import { usePrintout } from '@/components/calculator/printout/usePrintout';
import DealsApi from '@/modules/deals/services/DealsApi';
import { useModalInstance } from '@/composables/useModalInstance';
import { useInstance } from '@/composables/useInstance';
import DateUtils from '@/services/utils/DateUtils';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';


export default /*#__PURE__*/_defineComponent({
  __name: 'SendOrDownloadOffersModal',
  setup(__props) {

const tabsModel = ref<number>(1);
const sendLoading = ref<boolean>(false);
const downloadLoading = ref<boolean>(false);
const disabledActions = ref<boolean>(false);
const store = useSimulationStore();
const modal = useModalInstance();
const { $modalService, $snackbarService, $user, $errorHandler, } = useInstance();
const printout = usePrintout();

const prepareAnnSendOffers = async() => {
  disabledActions.value = true;
  if (!store.deal) {
    await pickDealToSimulation();
  }

  if (store.deal) {
    sendLoading.value = true;
    sendOffers();
  }

  disabledActions.value = false;
  sendLoading.value = false;
};

const sendOffers = async() => {
  const response = await $modalService.open<Deal>(SendOffersConfirmModal, { clients: store.deal!.clients, });
  if (response) {
    try {
      const url = await printout.getOffersPDFUrl();
      const fileName = printout.preparePrintoutName(store.simulationId || '');
      const sendOffersResponse = await DealsApi.sendSimulationPdf(store.deal!.id, $user.value.id, url, fileName);
      if (sendOffersResponse) {
        $snackbarService.openSuccessSnackbar(I18NGetter().useSimulationSendOrDownload.SENDING_OFFERS_SUCCESS);
      }
    } catch (e) {
      $errorHandler(e, I18NGetter().useSimulationSendOrDownload.SENDING_OFFERS_ERROR);
    } finally {
      modal.closeModal();
    }
  }
};

const pickDealToSimulation = async() => {
  const deal: Deal | null = await $modalService.open<Deal>(SimulationDealPicker, {
    productType: modal.modalData.productType,
    simulationId: store.simulationId,
    additionalInfo: I18NGetter().useSimulationSendOrDownload.LOAD_DEAL_INFO,
  }) ?? null;
  if (deal) {
    await store.init(store.productType!, store.simulationId, deal);
  }
};

const downloadPDF = async() => {
  downloadLoading.value = true;
  disabledActions.value = true;
  await printout.downloadSimulationPrintout();
  downloadLoading.value = false;
  disabledActions.value = false;
  modal.closeModal();
};

return { __sfc: true,tabsModel, sendLoading, downloadLoading, disabledActions, store, modal, $modalService, $snackbarService, $user, $errorHandler, printout, prepareAnnSendOffers, sendOffers, pickDealToSimulation, downloadPDF, PrintoutSettings, OffersPreview }
}

})